import React, { useCallback } from "react";
import { ImageComponent, ReactPortalComp } from "../../../../../components";

import { useBreakpointV2 } from "@tm/ui-widgets";
import CommonModalDweb from "../../../../../components/CommonModalDweb/CommonModalDweb";
import FormattedText, {
  getPlainText,
} from "../../../../../components/FormattedText/FormattedText";
import cancelGreyBg from "../../../../../icons/cancelGreyBg.svg";
import type { ViewDetailData } from "../../../types";
import {
  CloseButton,
  Overlay,
  SheetHeader,
  SheetPanel,
  SheetTitle,
  TravellerList,
  TravellerMeta,
  TravellerName,
  TravellerRow,
} from "./TravellerDetailModal.style";

interface TravellerDetailModalProps {
  data: ViewDetailData;
  onClose: () => void;
}

export function TravellerDetailModal({
  data,
  onClose,
}: TravellerDetailModalProps) {
  const device = useBreakpointV2();
  const title = getPlainText(data?.title).trim();
  const travellers = data?.travellers ?? [];

  const handleOverlayClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) onClose();
    },
    [onClose]
  );

  if (travellers.length === 0) return null;

  const travellerList = (
    <TravellerList>
      {travellers.map((t, idx) => {
        if (!t.name) return null;
        const meta = [t.gender, t.age].filter(Boolean).join(" | ");
        return (
          <TravellerRow key={t.name ?? idx}>
            <TravellerName>{t.name}</TravellerName>
            {meta ? <TravellerMeta>{` | ${meta}`}</TravellerMeta> : null}
          </TravellerRow>
        );
      })}
    </TravellerList>
  );

  if (device === "sm") {
    return (
      <ReactPortalComp>
        <Overlay onClick={handleOverlayClick}>
          <SheetPanel
            role="dialog"
            aria-modal="true"
            aria-label={title}
            $maxHeight="70vh"
            $padding="24px 30px 20px"
          >
            <SheetHeader>
              <SheetTitle>
                <FormattedText value={data?.title} />
              </SheetTitle>
              <CloseButton onClick={onClose} aria-label="Close">
                <ImageComponent
                  src={cancelGreyBg.src}
                  width="28px"
                  height="28px"
                  alt="Close"
                />
              </CloseButton>
            </SheetHeader>
            {travellerList}
          </SheetPanel>
        </Overlay>
      </ReactPortalComp>
    );
  }

  return (
    <CommonModalDweb
      customTitle={title}
      handleClick={onClose}
      customWidth="420px"
      customHeight="auto"
    >
      {travellerList}
    </CommonModalDweb>
  );
}
